$(document).ready(function () {

    //Убираем ошибку в input при его изменении
    $(document).on('input','.cell-input',function(event) {
        $(this).parents('.cell').removeClass('cell--error');
        $(this).parents('.cell').find('.cell__error-message').slideUp();

        $('.button--in-active').removeClass('button--in-active');
        $('.form-show').removeClass('form-show');
    });
});

//Проверка полей формы
function validator(form) {
    const inputs = form.find('.cell-input')
    let errorForm = false;

    //Показ ошибки в input
    inputs.each(function () {
        const cellBlock = $(this).parents('.cell')
        const errorBlock = cellBlock.find('.cell__error-message');

        if ($(this).attr('data-required') !== 'false'
            && $(this).attr('id') !== 'YII_CSRF_TOKEN'
            && $(this).attr('type') !== 'hidden'
            && $(this).attr('class') !== 'g-recaptcha-response') {

            const type = $(this).attr('data-type')
            let thisError;

            switch (type) {
                case 'inputmask':
                    thisError = errorFieldInputMask($(this));
                    break;
                case 'email':
                    thisError = errorFieldEmail($(this), errorBlock);
                    break;
                case 'birthday':
                    thisError = errorFieldBirthday($(this), errorBlock);
                    break;
                case 'birthdayBeneficiary':
                    thisError = errorFieldBirthdayBeneficiary($(this), errorBlock);
                break;
                case 'six-sign':
                    thisError = errorFieldSixSign($(this));
                    break;
                case 'four-sign':
                    thisError = errorFieldFourSign($(this));
                    break;
                default:
                    thisError = errorFieldText($(this));
            }

            if (thisError) {
                cellBlock.addClass('cell--error');
                errorBlock.slideDown();
                errorForm = true;
            }
        }
    });

    //Прокручиваем к первой ошибке
    if(errorForm){
        const errorInput = $('.cell--error, .checkbox--error, .radiobutton-calc--error').first();

        if (errorInput.length !== 0) {
            const scrollTop = errorInput.offset().top - 30;
            $('html, body').animate({ scrollTop: scrollTop }, 500);
        }
    }
    return errorForm
}

//Проверка заполненности поля (срабатывает по умолчанию на все поля даже без data-type)
function errorFieldText(el) {
    const val = el.val();
    return (val === '' || val === undefined)
}

//Проверка полного заполнения полей с маской плагина inputmask
function errorFieldInputMask(el) {
    return (!el.inputmask("isComplete"))
}

//Проверка email
function errorFieldEmail(el, errorBlock) {
    const value = el.val().trim();

    const emailRegex = /^(?!.*@.*@)(?!.*[.-]{2})(?!.*[а-яёА-ЯЁ])[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]{0,62}[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,62}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,62}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,10}$/;

    if (!value.length) {
        errorBlock.html('Заполните поле');
        return true;
    }

    if (!emailRegex.test(value)) {
        if (/[а-яё]/i.test(value)) {
            errorBlock.html('email должен содержать латинские буквы');
        } else {
            errorBlock.html('указан неверный email');
        }
        return true; // есть ошибка
    }

    errorBlock.html(''); // ошибок нет
    return false;
}

//Проверка инпута дня рождения
function errorFieldBirthday(el, errorBlock) {
    const val = convertsDateToIsoFormat(el.val());
    const currentDate = new Date().toISOString().slice(0, 10)

    if (el.inputmask("isComplete")) {
        if (currentDate <= val) {
            errorBlock.slideDown();
            return true
        } else {
            return false
        }
    } else {
        return true
    }

    // return (!el.inputmask("isComplete"))
}

function errorFieldBirthdayBeneficiary(el, errorBlock) {
    const val = convertsDateToIsoFormat(el.val());
    const currentDate = new Date().toISOString().slice(0, 10)

    if (el.inputmask("isComplete")) {
        const maxYearsAgo = new Date();
        maxYearsAgo.setFullYear(maxYearsAgo.getFullYear() - 120);
        const limit120 = maxYearsAgo.toISOString().slice(0, 10);

        if (val <= limit120 || currentDate <= val) {
            errorBlock.text("Проверьте правильность ввода даты рождения").slideDown();
            return true
        } else {
            return false
        }
    } else {
        return true
    }

    // return (!el.inputmask("isComplete"))
}

//Проверка инпута дня рождения
function errorFieldSixSign(el) {
    const val = el.val();

    return val.length < 6
}

function errorFieldFourSign(el) {
    const val = el.val();

    return val.length < 4
}
